<div class="dialog-wrapper" role="dialog" aria-modal="true" aria-labelledby="exit-dialog-title">
  <div class="dialog-icon" aria-hidden="true">
    <div class="icon-circle">
      <img src="assets/agricola/toast-warning.svg" alt="" aria-hidden="true">
    </div>
  </div>

  <h2 id="exit-dialog-title">¿Deseas salir de la gestión?</h2>
  <p class="subtitle">
    Si sales ahora, regresarás al inicio y la información de esta apertura quedará sin finalizar.
  </p>

  <div class="dialog-actions">
    <app-sis-button variant="secondary" (pressed)="stay()">Cancelar</app-sis-button>
    <app-sis-button (pressed)="leave()">Salir al inicio</app-sis-button>
  </div>
</div>
